import Layout from '@/components/Layout/Vanilla';
import Hero from '@/components/Hero';
import CardGrid from '@/components/CardGrid';
import ResourceCard from '@/components/ResourceCard';
import Section from '@/components/Section';
import { fetchPage, gql } from '@/lib/graphcms';

export default function Resources({ page, resources, preview }) {
  return (
    <Layout seo={page} preview={preview}>
      <Section>
        <Hero {...page} />
        <CardGrid
          entries={resources}
          Component={ResourceCard}
          linkSubpath="resources"
          truncatedText
          {...page}
        />
      </Section>
    </Layout>
  );
}

export const getStaticProps = async ({ preview = false }) => {
  const { page, resources, webinars } =
    (await fetchPage(
      gql`
        fragment resourceData on Resource {
          id
          slug
          title
          subTitle
          coverImage {
            ...assetDataSM
          }
          speakers {
            ...authorData
          }
          content
          externalUrl
          location
          starts
          ends
          type
          file {
            ...assetDataXL
          }
          preWebinarSuccessContent
          resourceUrl
          successContent
          meta: seo {
            ...seoData
          }
          mqlInterest
          hubSpotFormId
          formTitle
        }

        query academyPageQuery {
          page: page(where: { slug: "resources" }) {
            ...pageData # Fragment is inside the method
          }
          resources(
            orderBy: updatedAt_DESC
            where: { type_in: [EBOOK, REPORT, WHITEPAPER] }
          ) {
            ...resourceData
          }
          webinars: resources(
            orderBy: starts_DESC
            where: { type_in: [WEBINAR] }
          ) {
            ...resourceData
          }
        }
      `,
      {
        preview,
      },
    )) || [];

  const allResources = [...resources, ...webinars];

  return {
    props: {
      preview,
      page,
      resources: allResources,
    },
    revalidate: 3600,
  };
};
